"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavPanelMainComponent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Main = _interopRequireDefault(require("./Main.render"));
var _Menu = _interopRequireDefault(require("./Menu.render"));
var _withAnnouncements = _interopRequireDefault(require("../../../../HOCs/withAnnouncements"));
class NavPanelMainComponent extends _react.Component {
  constructor(props) {
    super(props);
    this.onBack = () => {
      this.setState(state => ({
        navTraversal: state.navTraversal.slice(0, -1)
      }));
    };
    this.onClose = () => {
      if (this.state.announcementsRead) {
        this.props.markAllAnnouncementsRead();
      }
      this.setState({
        navTraversal: [],
        selectedFooterSection: null
      });
      this.props.onClose();
    };
    this.onOpenSubMenu = index => {
      this.setState(state => ({
        navTraversal: [...state.navTraversal, index]
      }));
    };
    this.onSelectedFooterSectionChange = section => {
      this.setState({
        selectedFooterSection: section
      });
      if (section === 'ANNOUNCEMENTS') {
        this.setState({
          announcementsRead: true
        });
      }
    };
    this.onFooterClose = () => {
      if (this.state.announcementsRead) {
        this.props.markAllAnnouncementsRead();
      }
      this.setState({
        selectedFooterSection: null
      });
    };
    this.getItemsAndTitle = () => {
      let title = 'General.Menu';
      const {
        menuItems
      } = this.props;
      const {
        navTraversal
      } = this.state;
      let testSectionKey = '';
      let customRender;
      let items = menuItems && menuItems.primary;
      if (items) {
        navTraversal.forEach(i => {
          // @ts-ignore
          const nav = items[i];
          title = nav.text;
          // @ts-ignore
          items = nav.subMenu || [];
          // @ts-ignore
          testSectionKey = testSectionKey ? "".concat(testSectionKey, "-").concat(title) : title;
          customRender = nav.customRender;
        });
      }
      return {
        title,
        primaryItems: items || [],
        testSectionKey,
        customRender
      };
    };
    this.getServices = () => {
      const notShowIcons = ['ALERTS', 'SEARCH', 'AskICIS', 'Beta-AskICIS'];
      const {
        menuItems
      } = this.props;
      const items = menuItems && menuItems.services || [];
      // @ts-ignore
      return items.filter(x => !notShowIcons.includes(x.icon));
    };
    this.state = {
      navTraversal: [],
      selectedFooterSection: null,
      announcementsRead: false
    };
  }
  render() {
    const {
      show,
      menuItems,
      announcements,
      unreadAnnouncementsCount
    } = this.props;
    if (!show) return null;
    const {
      primaryItems,
      title,
      testSectionKey,
      customRender
    } = this.getItemsAndTitle();
    const hasBack = this.state.navTraversal.length > 0;
    return /*#__PURE__*/_react.default.createElement(_Main.default, {
      customRender: customRender,
      announcements: announcements,
      announcementsRead: this.state.announcementsRead,
      unreadAnnouncementsCount: unreadAnnouncementsCount,
      headerTitle: title,
      servicesNav: this.getServices(),
      hasBack: hasBack,
      selectedFooterSection: this.state.selectedFooterSection,
      onBack: this.onBack,
      onClose: this.onClose,
      onSelectedFooterSectionChange: this.onSelectedFooterSectionChange,
      onFooterClose: this.onFooterClose,
      openChangePasswordModal: this.props.openChangePasswordModal
    }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
      testSectionKey: testSectionKey,
      primaryItems: primaryItems,
      credits: menuItems && menuItems.credits,
      onOpenSubMenu: this.onOpenSubMenu,
      onClose: this.onClose,
      hasBack: hasBack,
      customRender: customRender,
      ModalComp: this.props.ModalComp
    }));
  }
}

// @ts-ignore
exports.NavPanelMainComponent = NavPanelMainComponent;
var _default = exports.default = (0, _withAnnouncements.default)(NavPanelMainComponent);